export default __webpack_public_path__ + "static/media/Data.eebcf577.svg";